import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { Job } from '@/types/job';

interface UseJobStatusReturn {
  job: Job | null;
  loading: boolean;
  error: string | null;
}

export function useJobStatus(jobId: string | null): UseJobStatusReturn {
  const [job, setJob] = useState<Job | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!jobId) {
      setJob(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = onSnapshot(
      doc(db, 'jobs', jobId),
      (snapshot) => {
        if (!snapshot.exists()) {
          setError('Job not found');
          setLoading(false);
          return;
        }
        setJob({ id: snapshot.id, ...snapshot.data() } as Job);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    return unsubscribe;
  }, [jobId]);

  return { job, loading, error };
}
